// extracted by mini-css-extract-plugin
export default {"texto":"styles_texto__qzP4O","input":"styles_input__U6YsG"};